/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Button, CircularProgress, Grid, Typography, Alert, InputAdornment, IconButton, FormControl, Box } from '@mui/material';
import { useState } from 'react';
import { Formik, Form, Field } from 'formik'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { makeStyles } from 'tss-react/mui';
import WebSDK from "@loginid/sdk";
import * as Yup from 'yup'
import { TextField } from 'formik-mui'
import { BsClipboard, BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import MainCard from '../../../../../../components/ui-elements/cards/MainCard';


const UserLoginIdCreation = () => {
 
    const [showPassword, setShowPassword] = useState(false)
    const [registerRslt, setRegisterRslt] = useState({})
    const { classes } = useStyles()

    const loginsdk = new WebSDK(process.env.REACT_APP_CLIENT_URL, process.env.REACT_APP_CLIENT_ID);


    const handleSubmit = async (user, { setSubmitting }) => {
        setSubmitting(true); 
        try {
            const result = await loginsdk.registerWithPassword(user.username, user.password, user.confirmPassword);
            setRegisterRslt(result)
            if (result) {
                setSubmitting(false);
             }
        } catch (error) { 

            setRegisterRslt(error);
            setSubmitting(false) ;
        }


    }
    return (


            <MainCard>
                <Box m={6}>
                    <Formik
                        initialValues={{
                            username: '',
                            password: '',

                            confirmPassword: ''
                        }}
                        validate={values => {
                            let errors = {};
                            const errorMsg = "Required ! Length must be between 2 and 24";
                            if (!values.username) {
                                errors.username = errorMsg;
                            }
                            if (!values.password) {
                                errors.password = "Required ! Length must be between at least 8";
                            }

                            if (values.password !== values.confirmPassword) {
                                errors.confirmPassword = 'Please make password confirm mutch password';
                            }
                            return errors;
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().min(6).max(24).required('username is required'),
                            password: Yup.string().min(8).max(30).required('password is required'),
                            confirmPassword: Yup.string().min(8).max(30).required('password is required')


                        })}
                        onSubmit={(
                            { username, password, confirmPassword }, { setSubmitting }
                        ) => {
                            handleSubmit({ username, password, confirmPassword }, { setSubmitting })
                        }
                        }
                    >
                        {({ isSubmitting, values, errors, touched, handleBlur, handleChange }) => (
                            <Form>
                                <FormControl fullWidth error={Boolean(touched.username && errors.username)}>

                                    <Field
                                        name="username"
                                        label="Username"
                                        type="text"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.username}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        component={TextField}

                                    /> 
                                </FormControl>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                            <Field
                                                name="password"
                                                label="Password"
                                                type={showPassword ? "text" : 'password'}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                value={values.password}
                                                component={TextField}
                                                InputProps={{

                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => { setShowPassword(!showPassword) }}
                                                            >
                                                                {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            /> 
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                            <Field
                                                value={values.confirmPassword}
                                                component={TextField}

                                                name="confirmPassword"
                                                label="Confirm Password"
                                                type={showPassword ? "text" : 'password'}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                InputProps={{

                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => { setShowPassword(!showPassword) }}
                                                            >
                                                                {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            /> 
                                        </FormControl>
                                    </Grid>

                                </Grid>


                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            className={classes.button}
                                            type="submit"
                                            disabled={isSubmitting}>
                                            {isSubmitting &&  <CircularProgress size={24} color="secondary" className={classes.buttonProgress} />}
                                            Register using LoginID
                                        </Button>

                                    </Grid>
                                </Grid>
                            </Form>

                        )}
                    </Formik>

                    {Object.keys(registerRslt).length !== 0 && <>
                        {registerRslt.is_authenticated ? (<Grid item xs={12} sm={12} md={12} style={{ marginTop: '30px' }} >
                            <Alert severity="success"> <Typography variant="h5">
                                {registerRslt.is_authenticated ? 'You are Registred successfully' : ''}
                            </Typography>
                            </Alert>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12}>

                                    {registerRslt.jwt && <>
                                        <CopyToClipboard text={registerRslt.jwt} >
                                            <Button variant="text" startIcon={<BsClipboard />} >
                                                <span style={{ color: 'black', marginRight: '10px' }}>  JWT : </span> {registerRslt.jwt.substring(0, 4)}...{registerRslt.jwt.substring(registerRslt.jwt.length - 3, registerRslt.jwt.length)}
                                            </Button>
                                        </CopyToClipboard></>

                                    }
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>

                                    {registerRslt.user && registerRslt.user.id && <>
                                        <CopyToClipboard text={registerRslt.user.id} >
                                            <Button variant="text" startIcon={<BsClipboard />} >
                                                <span style={{ color: 'black', marginRight: '10px' }}>  ID : </span> {registerRslt.user.id}
                                            </Button>
                                        </CopyToClipboard></>

                                    }
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>

                                    {registerRslt.user && registerRslt.user.username && <>
                                        <CopyToClipboard text={registerRslt.user.username} >
                                            <Button variant="text" startIcon={<BsClipboard />} >
                                                <span style={{ color: 'black', marginRight: '10px' }}>     Username : </span>  {registerRslt.user.username}
                                            </Button>
                                        </CopyToClipboard></>

                                    }
                                </Grid>
                            </Grid>


                        </Grid>) : (
                            <>
                                <Grid container spacing={2} style={{ marginTop: '30px' }}>
                                    <Grid item xs={12} sm={12} md={12}>

                                        <Alert severity="error"> <Typography variant="h5">
                                            <span style={{ color: 'black' }}>  Code :  </span> {registerRslt && registerRslt.code}
                                        </Typography>
                                        </Alert>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>

                                        <Alert severity="error"> <Typography variant="h5">
                                            <span style={{ color: 'black' }}> Message :  </span> {registerRslt && registerRslt.message}
                                        </Typography>
                                        </Alert>
                                    </Grid>
                                </Grid>

                            </>
                        )}
                    </>}
                </Box>
            </MainCard>
    )

}
const useStyles = makeStyles({ "name": { UserLoginIdCreation } })(theme => ({
    heroContent: {
        height: 'calc( 100vh - 150px)',
    },

    button: {
        margin: theme.spacing(1),
    },

    floatingLabelFocusStyle: {
        color: theme.palette.primary.main
    },
    ImgLoginDescp: {
        width: '400px',
        margin: 'auto',
        padding: '40px',
        display: 'block',
        color: 'white'
    },
    containerBox: {
        boxShadow: 'rgb(213 212 212 / 80%) 1px 5px 24px 0px',
        borderRadius: '10px',
        backgroundPosition: 'inherit',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: '100%'

    },
    BoxContainerLogin: {
        background: 'white',
        padding: '50px',
        borderRadius: '10px',
        boxShadow: 'rgb(38 127 161) 1px 5px 24px 0px',

    }
}))

export default UserLoginIdCreation;
